import { lazy } from "react";

const ExportList = lazy(() => import("./List"));
const ExportCreate = lazy(() => import("./Create"));
const ExportUpdate = lazy(() => import("./Update"));
const ExportPrint = lazy(() => import("./Print"));
const BeerList = lazy(() => import("./BeerList"));
const BeerFormPage = lazy(() => import("./BeerFormPage"));

export {
  BeerFormPage,
  BeerList,
  ExportCreate,
  ExportList,
  ExportPrint,
  ExportUpdate,
};
